import { AppCenterPopup, CenterPopupHeader } from "src/component"
import { CustomContainer, AppText, FlexRow, Button } from "src/style"

export const AcctDeletionTerms: React.FC<any> = ({next, close}) => {

    return (
        <AppCenterPopup close={close} height='45.5' zIndex='5' className='acct-deletion-terms-container' >
            <CenterPopupHeader close={close} />
            <CustomContainer height="35" className='popup-content-container'>
                <CustomContainer topMargin="1.5">
                    <AppText textSize="2.2" fontWeight="700" color="#000000" align="center" bottomMargin="1.5">
                        Terms & Conditions
                    </AppText>
                    <CustomContainer>
                        <AppText>
                            Here are the consequences and implications of deleting or deactivating a user profile.
                            The user will lose access to their accounts, data, previous transaction history, and access to carry out new transactions.
                        </AppText>
                        <AppText topMargin="1.5">
                            The user may not gain access to their account in any way or form on this application without 
                            contacting the bank to clarify the circumstances around the profile deletion.
                        </AppText>
                    </CustomContainer>
                    <FlexRow topMargin='2' gap="1.5" justifyContent="center">
                        <Button 
                            width='7.9' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            onClick={close}
                        >
                            Cancel
                        </Button>
                        <Button 
                            width='15' height="4"
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                            onClick={next}
                        >
                            Agree & Continue
                        </Button>
                    </FlexRow>
                </CustomContainer>
           </CustomContainer>
        </AppCenterPopup>
    )
}